import { useMemo } from 'react';

import type { ColGroupDef } from 'ag-grid-enterprise';

import type { SeedCountByMailCode } from '@enterprise/api';

import NumberCellRenderer from '@components/grid/renderers/number-cell.renderer';
import TotalCellRenderer from '@components/grid/renderers/total-cell-renderer';

export const useGetSeedCountByMailCodeColumns = () => {
  return useMemo(() => {
    return [
      {
        children: [
          {
            field: 'mailingId',
            headerName: 'Mailing ID',
            hide: true,
            width: 150,
          },
          {
            cellRenderer: TotalCellRenderer,
            field: 'mailCode',
            headerName: 'Mail Code',
            width: 250,
          },
        ],
        headerClass: ['bg-blue-950'],
        headerName: 'Mailing and List Information',
      },
      {
        children: [
          {
            aggFunc: 'sum',
            cellClass: ['bg-green-200', 'text-green-900'],
            field: 'seedTypeName',
            headerClass: ['bg-green-800'],
            headerName: 'Type',
            width: 175,
          },
          {
            aggFunc: 'sum',
            cellClass: ['bg-green-200', 'text-green-900'],
            cellRenderer: NumberCellRenderer,
            field: 'quantityFileCount',
            headerClass: ['bg-green-800'],
            headerName: 'Count',
            width: 175,
          },
        ],
        headerClass: ['bg-green-900'],
        headerGroupComponentParams: {
          icon: 'fa-user-plus',
        },
        headerName: 'Seed Information',
      },
    ] as ColGroupDef<SeedCountByMailCode>[];
  }, []);
};
